import Header from "src/components/Header";

export default function PanelLayout({ children }) {
    return (
            <div>
                {/* <Header /> */}
                <div className="w-[1140px] m-auto my-5">{children}</div>
            </div>
    )
}